<template>
  <div class="card-back">
    <AnimatedTitle :animated="false"></AnimatedTitle>
  </div>
</template>

<script>
  import Card from '@/models/Card';


  export default {
    name: 'CardBack',
    props: {
      card: { type: Card, required: true },
    },
  };
</script>

<style scoped lang="scss">
  @import "../../config/styles/settings";
  @import "../../config/styles/util";

  .card-back {
    cursor: pointer;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $blue-300;
    border-radius: 3px;
    border: 1px solid $blue-500;
    font-size: 2rem;
  }
</style>
